{
  "nm": "Flow 1",
  "ddd": 0,
  "h": 192,
  "w": 192,
  "meta": { "g": "LottieFiles Figma v67" },
  "layers": [
    {
      "ty": 4,
      "nm": "Green check",
      "sr": 1,
      "st": 0,
      "op": 170.97,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [18, 18],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [18, 18],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [18, 18],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [18, 18],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [18, 18],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [18, 18],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [18, 18],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [18, 18],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [18, 18],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [18, 18],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [18, 18],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [18, 18],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [18, 18],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [18, 18],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [18, 18],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [18, 18],
              "t": 170
            },
            { "s": [18, 18], "t": 182 }
          ]
        },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100, 100],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100, 100],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100, 100],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 170
            },
            { "s": [100, 100], "t": 182 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 119],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 119],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 119],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 119],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 119],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 119],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 119],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 101.55],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 103.09],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 103],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 103],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 103],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 120.45],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 118.91],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 119],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 119],
              "t": 170
            },
            { "s": [96, 119], "t": 182 }
          ]
        },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [0],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [0],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [0],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 170
            },
            { "s": [0], "t": 182 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [0],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [99.46],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [0],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [0.54],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 170
            },
            { "s": [0], "t": 182 }
          ]
        }
      },
      "shapes": [
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.93938],
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0]
                    ],
                    "o": [
                      [9.9394, 0],
                      [0, 9.9394],
                      [-9.93938, 0],
                      [0, -9.93938],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.94],
                      [9.94, 0],
                      [0, 9.94],
                      [-9.94, 0]
                    ],
                    "o": [
                      [9.94, 0],
                      [0, 9.94],
                      [-9.94, 0],
                      [0, -9.94],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 170
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -9.94],
                      [9.94, 0],
                      [0, 9.94],
                      [-9.94, 0]
                    ],
                    "o": [
                      [9.94, 0],
                      [0, 9.94],
                      [-9.94, 0],
                      [0, -9.94],
                      [0, 0]
                    ],
                    "v": [
                      [18, 0],
                      [36, 18],
                      [18, 36],
                      [0, 18],
                      [18, 0]
                    ]
                  }
                ],
                "t": 182
              }
            ]
          }
        },
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.7509200000000007, 0.751100000000001],
                      [-0.7455999999999996, -0.7462],
                      [0, 0],
                      [0, 0],
                      [-0.7508999999999979, -0.7510999999999992],
                      [0.75, -0.75],
                      [0, 0],
                      [0.7508999999999997, 0.7510999999999974],
                      [0.019899999999999807, 0.02190000000000225]
                    ],
                    "o": [
                      [0, 0],
                      [-0.750770000000001, -0.7512000000000008],
                      [0.7510699999999986, -0.7508999999999997],
                      [0, 0],
                      [0, 0],
                      [0.751100000000001, -0.7510999999999992],
                      [0.751100000000001, 0.7508999999999997],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.021099999999998786, -0.021100000000000563],
                      [0, 0]
                    ],
                    "v": [
                      [14.2621, 23.8465],
                      [9.85523, 19.436],
                      [9.85523, 16.7087],
                      [12.5824, 16.7087],
                      [15.6892, 19.818],
                      [23.4179, 12.0893],
                      [26.145, 12.0893],
                      [26.145, 14.8165],
                      [17.0506, 23.9109],
                      [14.3234, 23.9109],
                      [14.2621, 23.8465]
                    ]
                  }
                ],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.75, -0.75],
                      [0, 0],
                      [0, 0],
                      [-0.75, -0.75],
                      [0.75, -0.75],
                      [0, 0],
                      [0.75, 0.75],
                      [0.02, 0.02]
                    ],
                    "o": [
                      [0, 0],
                      [-0.75, -0.75],
                      [0.75, -0.75],
                      [0, 0],
                      [0, 0],
                      [0.75, -0.75],
                      [0.75, 0.75],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.02, -0.02],
                      [0, 0]
                    ],
                    "v": [
                      [14.26, 23.85],
                      [9.86, 19.44],
                      [9.86, 16.71],
                      [12.58, 16.71],
                      [15.69, 19.82],
                      [23.42, 12.09],
                      [26.15, 12.09],
                      [26.15, 14.82],
                      [17.05, 23.91],
                      [14.32, 23.91],
                      [14.26, 23.85]
                    ]
                  }
                ],
                "t": 170
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.75, -0.75],
                      [0, 0],
                      [0, 0],
                      [-0.75, -0.75],
                      [0.75, -0.75],
                      [0, 0],
                      [0.75, 0.75],
                      [0.02, 0.02]
                    ],
                    "o": [
                      [0, 0],
                      [-0.75, -0.75],
                      [0.75, -0.75],
                      [0, 0],
                      [0, 0],
                      [0.75, -0.75],
                      [0.75, 0.75],
                      [0, 0],
                      [-0.75, 0.75],
                      [-0.02, -0.02],
                      [0, 0]
                    ],
                    "v": [
                      [14.26, 23.85],
                      [9.86, 19.44],
                      [9.86, 16.71],
                      [12.58, 16.71],
                      [15.69, 19.82],
                      [23.42, 12.09],
                      [26.15, 12.09],
                      [26.15, 14.82],
                      [17.05, 23.91],
                      [14.32, 23.91],
                      [14.26, 23.85]
                    ]
                  }
                ],
                "t": 182
              }
            ]
          }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0.7295, 0],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0.7295, 0],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [0, 0.7295, 0],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0.7295, 0],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0.7295, 0],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0.7295, 0],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0.7295, 0],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [0, 0.7295, 0],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0.7295, 0],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0.7295, 0],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0.7295, 0],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0.7295, 0],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [0, 0.7295, 0],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0.7295, 0],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0.7295, 0],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0.7295, 0],
                "t": 170
              },
              { "s": [0, 0.7295, 0], "t": 182 }
            ]
          },
          "r": 2,
          "o": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [100],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [100],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [100],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 170
              },
              { "s": [100], "t": 182 }
            ]
          }
        }
      ],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Union",
      "sr": 1,
      "st": 0,
      "op": 170.97,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [56, 70],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [56, 70],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [56, 70],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [56, 70],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [56, 70],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [56, 70],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [56, 70],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [56, 70],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [56, 70],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [56, 70],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [56, 70],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [56, 70],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [56, 70],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [56, 70],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [56, 70],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [56, 70],
              "t": 170
            },
            { "s": [56, 70], "t": 182 }
          ]
        },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100, 100],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100, 100],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100, 100],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 170
            },
            { "s": [100, 100], "t": 182 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 96],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 96],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 96],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 170
            },
            { "s": [96, 96], "t": 182 }
          ]
        },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [-90],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [-90],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [8.16],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [-0.49],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [0.01],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [0],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [-98.16],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [-89.51],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [-90.01],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [-90],
              "t": 170
            },
            { "s": [-90], "t": 182 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 41.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 56.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 57
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 69
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100],
              "t": 83.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 98.77022171020508
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 113
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 113.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 125
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100],
              "t": 139.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 154.77022171020508
            },
            {
              "o": { "x": 1, "y": 1 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 169.65533256530762
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 170
            },
            { "s": [100], "t": 182 }
          ]
        }
      },
      "shapes": [
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.1060300000000005],
                      [0, 0],
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15466, 0],
                      [0, 0],
                      [0, 5.1059999999999945],
                      [0, 0],
                      [5.153999999999996, 0],
                      [0, 0],
                      [0, -5.10603],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33334, 0],
                      [0, 9.24529],
                      [0, 130.755],
                      [9.33334, 140],
                      [102.667, 140],
                      [112, 130.755],
                      [112, 9.24528],
                      [102.667, 0],
                      [9.33334, 0]
                    ]
                  }
                ],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.11],
                      [0, 0],
                      [-5.15, 0],
                      [0, 0],
                      [0, 5.11],
                      [0, 0],
                      [5.15, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15, 0],
                      [0, 0],
                      [0, 5.11],
                      [0, 0],
                      [5.15, 0],
                      [0, 0],
                      [0, -5.11],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33, 0],
                      [0, 9.25],
                      [0, 130.76],
                      [9.33, 140],
                      [102.67, 140],
                      [112, 130.76],
                      [112, 9.25],
                      [102.67, 0],
                      [9.33, 0]
                    ]
                  }
                ],
                "t": 170
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, -5.11],
                      [0, 0],
                      [-5.15, 0],
                      [0, 0],
                      [0, 5.11],
                      [0, 0],
                      [5.15, 0],
                      [0, 0]
                    ],
                    "o": [
                      [-5.15, 0],
                      [0, 0],
                      [0, 5.11],
                      [0, 0],
                      [5.15, 0],
                      [0, 0],
                      [0, -5.11],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [9.33, 0],
                      [0, 9.25],
                      [0, 130.76],
                      [9.33, 140],
                      [102.67, 140],
                      [112, 130.76],
                      [112, 9.25],
                      [102.67, 0],
                      [9.33, 0]
                    ]
                  }
                ],
                "t": 182
              }
            ]
          }
        },
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, -0.7294299999999989],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.7294400000000003],
                      [0, 0],
                      [0.7360000000000042, 0],
                      [0, 0],
                      [0, 0.7290000000000134],
                      [0, 0],
                      [-0.7363800000000005, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.24529],
                      [9.33334, 7.92453],
                      [102.667, 7.92453],
                      [104, 9.24528],
                      [104, 130.755],
                      [102.667, 132.075],
                      [9.33334, 132.075],
                      [8, 130.755],
                      [8, 9.24529]
                    ]
                  }
                ],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.74, 0],
                      [0, 0],
                      [0, -0.73],
                      [0, 0],
                      [0.74, 0],
                      [0, 0],
                      [0, 0.73],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.73],
                      [0, 0],
                      [0.74, 0],
                      [0, 0],
                      [0, 0.73],
                      [0, 0],
                      [-0.74, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.25],
                      [9.33, 7.92],
                      [102.67, 7.92],
                      [104, 9.25],
                      [104, 130.76],
                      [102.67, 132.07],
                      [9.33, 132.07],
                      [8, 130.76],
                      [8, 9.25]
                    ]
                  }
                ],
                "t": 170
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-0.74, 0],
                      [0, 0],
                      [0, -0.73],
                      [0, 0],
                      [0.74, 0],
                      [0, 0],
                      [0, 0.73],
                      [0, 0]
                    ],
                    "o": [
                      [0, -0.73],
                      [0, 0],
                      [0.74, 0],
                      [0, 0],
                      [0, 0.73],
                      [0, 0],
                      [-0.74, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [8, 9.25],
                      [9.33, 7.92],
                      [102.67, 7.92],
                      [104, 9.25],
                      [104, 130.76],
                      [102.67, 132.07],
                      [9.33, 132.07],
                      [8, 130.76],
                      [8, 9.25]
                    ]
                  }
                ],
                "t": 182
              }
            ]
          }
        },
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0],
                      [0, -2.209000000000003],
                      [2.2091000000000065, 0],
                      [0, 0],
                      [0, 2.209000000000003]
                    ],
                    "o": [
                      [0, -2.209000000000003],
                      [0, 0],
                      [2.2091000000000065, 0],
                      [0, 2.209000000000003],
                      [0, 0],
                      [-2.2090999999999994, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.21, 0],
                      [0, 0],
                      [0, -2.21],
                      [2.21, 0],
                      [0, 0],
                      [0, 2.21]
                    ],
                    "o": [
                      [0, -2.21],
                      [0, 0],
                      [2.21, 0],
                      [0, 2.21],
                      [0, 0],
                      [-2.21, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 170
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [-2.21, 0],
                      [0, 0],
                      [0, -2.21],
                      [2.21, 0],
                      [0, 0],
                      [0, 2.21]
                    ],
                    "o": [
                      [0, -2.21],
                      [0, 0],
                      [2.21, 0],
                      [0, 2.21],
                      [0, 0],
                      [-2.21, 0],
                      [0, 0]
                    ],
                    "v": [
                      [28, 118],
                      [32, 114],
                      [80, 114],
                      [84, 118],
                      [80, 122],
                      [32, 122],
                      [28, 118]
                    ]
                  }
                ],
                "t": 182
              }
            ]
          }
        },
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.418300000000002],
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0]
                    ],
                    "o": [
                      [4.418300000000002, 0],
                      [0, -4.418299999999999],
                      [-4.418300000000002, 0],
                      [0, 4.418300000000002],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.42],
                      [4.42, 0],
                      [0, -4.42],
                      [-4.42, 0]
                    ],
                    "o": [
                      [4.42, 0],
                      [0, -4.42],
                      [-4.42, 0],
                      [0, 4.42],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 170
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 4.42],
                      [4.42, 0],
                      [0, -4.42],
                      [-4.42, 0]
                    ],
                    "o": [
                      [4.42, 0],
                      [0, -4.42],
                      [-4.42, 0],
                      [0, 4.42],
                      [0, 0]
                    ],
                    "v": [
                      [56, 38],
                      [64, 30],
                      [56, 22],
                      [48, 30],
                      [56, 38]
                    ]
                  }
                ],
                "t": 182
              }
            ]
          }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0, 0],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0, 0],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [0, 0, 0],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0, 0],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0, 0],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0, 0],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0, 0],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [0, 0, 0],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0, 0],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0, 0],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0, 0],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [0, 0, 0],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [0, 0, 0],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0, 0],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0, 0],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 0, 0],
                "t": 170
              },
              { "s": [0, 0, 0], "t": 182 }
            ]
          },
          "r": 2,
          "o": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [100],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 41.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 56.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 57
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 69
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [100],
                "t": 83.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 98.77022171020508
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 113
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 113.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 125
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [100],
                "t": 139.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 154.77022171020508
              },
              {
                "o": { "x": 1, "y": 1 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 169.65533256530762
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 170
              },
              { "s": [100], "t": 182 }
            ]
          }
        }
      ],
      "ind": 2
    },
    {
      "ty": 4,
      "nm": "One Bg",
      "sr": 1,
      "st": 0,
      "op": 170.97,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 96],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 41.77022171020508
            },
            { "s": [96, 96], "t": 56.65533256530762 }
          ]
        },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100, 100],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100, 100],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 41.77022171020508
            },
            { "s": [100, 100], "t": 56.65533256530762 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [96, 96],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [96, 96],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [96, 96],
              "t": 41.77022171020508
            },
            { "s": [96, 96], "t": 56.65533256530762 }
          ]
        },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [0],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [0],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 41.77022171020508
            },
            { "s": [0], "t": 56.65533256530762 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1.11, "y": 1.11 },
              "s": [100],
              "t": 12
            },
            {
              "o": { "x": 1.11, "y": 1.11 },
              "i": { "x": 0.99, "y": 0.99 },
              "s": [100],
              "t": 26.88511085510254
            },
            {
              "o": { "x": 0.99, "y": 0.99 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 41.77022171020508
            },
            { "s": [100], "t": 56.65533256530762 }
          ]
        }
      },
      "shapes": [
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [192, 0],
                      [192, 192],
                      [0, 192],
                      [0, 0]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [192, 0],
                      [192, 192],
                      [0, 192],
                      [0, 0]
                    ]
                  }
                ],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [192, 0],
                      [192, 192],
                      [0, 192],
                      [0, 0]
                    ]
                  }
                ],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [192, 0],
                      [192, 192],
                      [0, 192],
                      [0, 0]
                    ]
                  }
                ],
                "t": 41.77022171020508
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [192, 0],
                      [192, 192],
                      [0, 192],
                      [0, 0]
                    ]
                  }
                ],
                "t": 56.65533256530762
              }
            ]
          }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [1, 1, 1],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [1, 1, 1],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [1, 1, 1],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [1, 1, 1],
                "t": 41.77022171020508
              },
              { "s": [1, 1, 1], "t": 56.65533256530762 }
            ]
          },
          "r": 1,
          "o": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1.11, "y": 1.11 },
                "s": [100],
                "t": 12
              },
              {
                "o": { "x": 1.11, "y": 1.11 },
                "i": { "x": 0.99, "y": 0.99 },
                "s": [100],
                "t": 26.88511085510254
              },
              {
                "o": { "x": 0.99, "y": 0.99 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 41.77022171020508
              },
              { "s": [100], "t": 56.65533256530762 }
            ]
          }
        }
      ],
      "ind": 3
    }
  ],
  "v": "5.7.0",
  "fr": 60,
  "op": 169.97,
  "ip": 0,
  "assets": []
}
